function reloadMiniCartAjax(){
  const cartDrawer = $('.cart-drawer');
  const miniCartBodyContainer = $('.js-cart-drawer-container');
  
  // Rerender mini cart
  cartDrawer.addClass('expanded loading-icon');
  
  jQuery.get(window.Shopify.routes.root + 'cart')
    .done(function(res){
      const $res = $($.parseHTML(res));
      const output = $res.find(".js-cart-drawer-ajax").html();
      const preOrderOutput = $res.find(".js-cart-drawer-pre-order-alert-ajax").html();
      miniCartBodyContainer.html(output);
      const $preOrderContainer = $('.js-cart-drawer-pre-order-alert');
      const $preOrderAlert = $('<div>').html(preOrderOutput || '').find('.cart__pre-order-alert');
      if ($preOrderAlert.length) {
        const $existingAlert = $preOrderContainer.find('.cart__pre-order-alert');
        if ($existingAlert.length) {
          $existingAlert.replaceWith($preOrderAlert);
        } else {
          $preOrderContainer.append($preOrderAlert);
        }
      } else {
        $preOrderContainer.find('.cart__pre-order-alert').remove();
      }
      cartDrawer.removeClass('loading-icon');
      document.dispatchEvent(new CustomEvent('cart-drawer:updated'));

      const itemCount = (
        $res.find('.js-cart-section > .item-counter').first().text() ||
        $res.find('.js-cart-drawer-ajax > .item-counter').first().text()
      ).trim();
      if (itemCount) {
        $('.btn-cart__counter').text(itemCount);
      }
      if (typeof window.updateCartDrawerItemCount === 'function') {
        window.updateCartDrawerItemCount();
      }
    })
  // Update free shipping prodgress bar
  jQuery.get(window.Shopify.routes.root + 'cart.js')
    .done(function(res){
      const data = JSON.parse(res);
      const freeShippingThreshold = 1995
      const subtotal = data.items_subtotal_price / 100;
      const percentageToBeFreeShipping = 100 * subtotal / freeShippingThreshold;
      let isQualifiedFreeShipping = subtotal >= freeShippingThreshold;
      
      let progressBarLabel = "Add P" + (freeShippingThreshold - subtotal) + " more to get free shipping";
      
      if (isQualifiedFreeShipping) {
          progressBarLabel = "Congrats! You get free shipping ✨";
      }
      $('.cart-progress').css('display', 'block');
      $('.cart-progress-status').text(progressBarLabel);
      $('.cart-progress-bar__filled').css('width', `${percentageToBeFreeShipping}%`);
    });
}

// Readers collection page
const readersCollection = document.getElementById("readers")

// const readersProductCard = document.querySelectorAll(".readers-frame")
// readersProductCard.forEach(item => {
//   item.querySelector(".btn-readers").innerText = "Select lenses"
// })

// setTimeout(() => {
//   readersCollection.querySelectorAll(".btn-quick-add").forEach(btn => {
//     btn.innerText = "Select lenses"
//   })
// }, 1000);

// End - Readers collection page

function initializeGenericSwiper() {
  new Swiper(".generic-swiper", {
    slidesPerView: 2,
    spaceBetween: 12,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      1240: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },
    pagination: {
      el: ".generic-swiper-pagination",
      clickable: true,
    },
    on: {
      init: function () {
        const genericSwiper = document.getElementsByClassName("generic-swiper");

        for (swiper of genericSwiper) {
          swiper.style.display = "block";
        }
      },
    },
  });
}

initializeGenericSwiper();

// PDP Grades side copy

setTimeout(() => {


  const gradeModalTrigger = document.querySelector("#grade-popup-trigger");

  const gradeModal = document.querySelector(".grades-modal");
  const closeGradeModal = document.querySelector(".close-grades-modal");
  const darkUnderlay = document.querySelector(".dark-underlay");
  try {
    gradeModalTrigger.addEventListener("click", () => {
      gradeModal.classList.add("active");
      darkUnderlay.classList.add("active");
    });

    closeGradeModal.addEventListener("click", () => {
      gradeModal.classList.remove("active");
      darkUnderlay.classList.remove("active");
    });
  
    darkUnderlay.addEventListener("click", (e) => {
      gradeModal.classList.remove("active");
      darkUnderlay.classList.remove("active");
    });
    
  } catch (error) {
    
  }


}, 4000);

const readersTemplate = document.querySelector(".template-product"); // will change identifier

const accordionContents = readersTemplate?.querySelectorAll(
  ".Product__accordion-item-content",
);
accordionContents?.forEach((content) => {
  if (content.innerHTML.includes("--")) {
    const newText = content.innerHTML.replaceAll("--", "&#8226; ");
    content.innerHTML = newText;
  }
});
// End - PDP Grades side copy

// add to cart - mini product
// function addMiniProduct(id, type = null) {

//   let setData;
//   if (type !== null) {
//     setData = {
//       items: [
//         {
//           id: id,
//           quantity: 1,
//           properties: {
//             _item_type: type
//           }
//         },
//       ],
//     };
//   } else {
//     setData = {
//       items: [
//         {
//           id: id,
//           quantity: 1,
//         },
//       ],
//     };
//   }

//   const addData = setData;

//   fetch("/cart/add.js", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(addData),
//   })
//     .then((res) => {
//       if (res.status === 200) {
//         window.location.reload();
//       }
//     })
//     .catch((err) => console.error(err));
// }
function addMiniProduct(id, type = null, e) {
  const button = $(e.currentTarget )
  
  button.addClass("loading")
  
  let setData;
  if (type !== null) {
    setData = {
      items: [
        {
          id: id,
          quantity: 1,
          properties: {
            _item_type: type
          }
        },
      ],
    };
  } else {
    setData = {
      items: [
        {
          id: id,
          quantity: 1,
        },
      ],
    };
  }

  const addData = setData;

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(addData),
  })
    .then((res) => {
      if (res.status === 200) {
        reloadMiniCartAjax();
      }
      button.removeClass("loading")
      button.addClass("success")
      setTimeout(()=>{
         button.removeClass("success")
      },2000)
    })
    .catch((err) => {
      console.error(err)
      button.removeClass("loading")
    });
}
// End - add to cart - mini product

// remove to cart -- pwp
function removePWP(id) {

  const removeData = {
    id: id,
    quantity: 0,
  };

  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(removeData),
  })
    .then((res) => {
      if (res.status === 200) {
        window.location.reload(true);
      }
    })
    .catch((err) => console.error(err));
}
// End - remove to cart -- pwp

// Move callout popup
$(document).ready(function() {
  $("body").on('DOMSubtreeModified', ".cart-drawer", function() {
    if ($('.temp-modal').length) {
      $('.cloned-modal').remove();
      $('#dcd-modal').appendTo('body').attr('class', 'cloned-modal');
      $('.temp-modal').remove();
    }
  });
})
